module.exports = "<table class=\"report-summary\" border=\"1\">\r\n  <tr ng-repeat=\"row in $ctrl.summaryMatrix\">                \r\n    <td class=\"key\" ng-repeat=\"col in row\">{{col.item1}}: {{col.item2}}</td>\r\n  </tr>\r\n</table>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/reports/reportSummary/reportSummary.html
// module id = 1628
// module chunks = 0